export default __webpack_public_path__ + "static/media/support-icon.44996063.svg";